import { Box, Text } from '@chakra-ui/react';
import { MhyChakraProps, OfficeTeaser as Props } from '../types';
import { MetaContent } from './BasicBlocks';
import Buttons, { ButtonsProps } from './Buttons';
import Link from './Link';
import Heading from './Heading';
import { useTranslation } from '../lib/hooks.context';
import {
  formatPhoneNumber,
  formatAddressFromLocation as formatAddress,
} from '../lib/utils';

const spacing = [2, 3, 4];
const OfficeTeaser = ({
  title,
  location,
  display_address: displayAddress,
  email,
  phone,
  description,
  all_link,
  ...rest
}: Props & MhyChakraProps) => {
  const t = useTranslation();
  const buttons: ButtonsProps['buttons'] = [];

  if (phone) {
    buttons.push({
      link: {
        title: t('call_phone', { phone: formatPhoneNumber(phone) }),
        url: `tel:${phone.replace(/\s/, '')}`,
      },
    });
  }
  if (all_link) {
    buttons.push({ link: all_link });
  }

  return (
    <MetaContent as="section" {...rest}>
      <Box>
        <Heading as="h2" variant="h4" mb={spacing}>
          {title}
        </Heading>
        {description && <Text mb={spacing}>{description}</Text>}
        {displayAddress && (
          <Text
            mb={spacing}
            dangerouslySetInnerHTML={{ __html: displayAddress }}
          />
        )}
        {!displayAddress && location && (
          <Text mb={spacing}>{formatAddress(location)}</Text>
        )}
        {email && (
          <Link href={`mailto: ${email}`} mb={spacing} display="inline-block">
            {email}
          </Link>
        )}
        {phone && <Buttons buttons={buttons} />}
      </Box>
    </MetaContent>
  );
};

export default OfficeTeaser;
